import { createSlice } from '@reduxjs/toolkit';
import { Document, documentsApi, getAllDocuments } from '_services/documents';
import { DateTime } from 'luxon';

type DocumentsState = {
  documents: Array<Document>;
};

const initialState: DocumentsState = {
  documents: [],
};

const slice = createSlice({
  name: 'documents',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(getAllDocuments.matchFulfilled, (state, action) => {
      state.documents = action.payload.documents
        .map((document) => {
          return {
            ...document,
            updated_at: DateTime.fromISO(document.updated_at)
              .setLocale('fr')
              .toFormat('dd/MM/yyyy HH:mm:ss'),
          };
        });
    });
  },
});

export default slice.reducer;
